import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

import { Modal } from "react-bootstrap";
import Icon from "components/Icon/Icon";
import { X } from "@phosphor-icons/react";
import Button from "components/Buttons";
import { UserActivateModalStyles } from "pages/Users/Modals/UserActivateModal/styled";
import { useCreatorUsersSlice } from "pages/CreatorUsers/slice";

const CreatorUserActivateModal = ({
  show,
  onHide,
  userInfo,
  loading,
  updateType = null,
  currentStatus
}) => {
  const dispatch = useDispatch();
  const { actions: creatorActions } = useCreatorUsersSlice();
  const secret_code = process.env.REACT_APP_SECRET_CODE;

  const handleApiCall = () => {
    dispatch(
      creatorActions.restrictCreatorUserRequest({
        creator_user_id: userInfo.id,
        secret_code,
        status: currentStatus,
      })
    );
    onHide();
  };

  return (
    <UserActivateModalStyles
      show={show}
      className="centered-modal"
      backdrop={loading ? "static" : true}
    >
      <Modal.Header>
        <Modal.Title>
          {currentStatus === "restricted" ? "Restrict" : "Activate"} this
          Account?
        </Modal.Title>
        <div onClick={onHide} className="close-icon-wrapper">
          <Icon component={X} size={24} />
        </div>
      </Modal.Header>

      <Modal.Body>
        {currentStatus === "restricted" ? (
          <p>
            Restricting this account will block the user&lsquo;s access to the
            app. They will not be able to use any features until the restriction
            is removed.
          </p>
        ) : (
          <p>
            Activating this account will restore full access to the app and all
            related features.
          </p>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        {currentStatus === "restricted" ? (
          <Button
            variant="primary"
            colorScheme="error"
            size="M"
            onClick={handleApiCall}
          >
            Restrict Account
          </Button>
        ) : (
          <Button variant="primary" size="M" onClick={handleApiCall}>
            Activate Account
          </Button>
        )}
      </Modal.Footer>
    </UserActivateModalStyles>
  );
};

export default CreatorUserActivateModal;
